import React from "react"

export default ({ children, ...props }) => (
  <ul {...props}>
    {children}
  </ul>
)
